/**
 * Route for `creator-promo`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreatorPromoPage } from "../features/creator-promo/CreatorPromoPage";

export const creatorPromoRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creator-promo",
	component: CreatorPromoPage,
});

export default creatorPromoRoute;
